var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotOffers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M33.094 26.062c-.087-1.342-.33-2.487-.766-3.579 0 0 0-.036-.017-.053-.018-.054-2.404-6.013-1.29-9.288a.975.975 0 0 0-.121-.877.89.89 0 0 0-.784-.376c-.087 0-1.741.108-3.5 1.7-1.55-3.274-1.794-6.746-1.794-6.782a.933.933 0 0 0-.488-.77.87.87 0 0 0-.906.037c-2.438 1.503-4.32 3.364-5.59 5.476a13.65 13.65 0 0 0-1.882 5.636 14.48 14.48 0 0 0 0 3.257.563.563 0 0 1-.766.59l-2.368-1.001a.97.97 0 0 0-.506-.072c-.365.054-.644.322-.748.68-.21.77-.384 1.467-.488 2.165-.4 2.398-.244 4.868.47 7.122.714 2.273 1.968 4.224 3.588 5.655 1.933 1.682 4.267 2.541 6.81 2.541 1.41 0 2.873-.268 4.371-.787 2.386-.841 4.267-2.505 5.452-4.796.992-1.915 1.445-4.205 1.323-6.46v-.018z",
    fill: "url(#psfnk9oyaa)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M17.002 35.546c1.672 1.468 3.657 2.327 5.817 2.523-.279 0-.575.036-.854.036-2.543 0-4.876-.859-6.81-2.559-1.62-1.413-2.873-3.364-3.587-5.636-.714-2.255-.871-4.725-.47-7.14.104-.68.278-1.396.487-2.166a.91.91 0 0 1 .731-.662.89.89 0 0 1 .523.072l.731.304s-.104.179-.139.286c-.226.77-.383 1.486-.488 2.166a15.18 15.18 0 0 0 .47 7.14c.715 2.272 1.969 4.223 3.588 5.636z",
    fill: "url(#xt50j21gdb)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.351 6.002c.157.09.296.215.383.394-2.177 1.431-3.866 3.15-5.033 5.118a13.93 13.93 0 0 0-1.898 5.637 16.884 16.884 0 0 0 0 3.256.559.559 0 0 1-.767.59l-1.097-.464s.017-.072.017-.126c-.087-.93-.121-2.04.018-3.256a13.65 13.65 0 0 1 1.88-5.637c1.272-2.13 3.153-3.973 5.592-5.494a.909.909 0 0 1 .905-.018z",
    fill: "url(#pxqo9wq3rc)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.49 22.25a.89.89 0 0 0-1.062-.357.933.933 0 0 0-.61.966c.105 1.503-.034 5.941-2.072 6.514-1.742.483-2.665-.34-2.752-.43a.911.911 0 0 0-.888-.268.954.954 0 0 0-.662.68c0 .071-.174.662-.244 1.038-.418 2.47.366 4.92 2.055 6.406.993.859 2.178 1.306 3.466 1.306.714 0 1.446-.125 2.195-.393 1.219-.43 2.247-1.325 2.995-2.613.627-1.074.993-2.326.993-3.436.018-2.845-1.027-5.762-3.43-9.43l.017.017z",
    fill: "url(#um7og7ka5d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30.813 12.14c-.645.215-1.48.644-2.351 1.414-.157-.34-.296-.662-.436-1.002 1.167-.627 2.038-.68 2.108-.68.243-.018.487.089.679.268z",
    fill: "url(#8bgb6udtie)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m14.685 20.014 1.254.519a.54.54 0 0 1-.749.465l-1.62-.68a.89.89 0 0 1 1.115-.304z",
    fill: "url(#6dhdlqg73f)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.993 6.772a.93.93 0 0 0-.105-.376c.174-.143.366-.25.558-.376a.909.909 0 0 1 .905-.018c.279.143.47.447.488.77 0 .035.192 2.845 1.358 5.78a6.883 6.883 0 0 0-1.41 1.002c-1.55-3.275-1.794-6.747-1.794-6.782zM33.112 26.044c.122 2.255-.331 4.563-1.324 6.46-1.184 2.309-3.065 3.973-5.451 4.814-1.498.519-2.961.787-4.372.787-.33 0-.662-.018-.993-.035 1.15-.09 2.317-.34 3.519-.752 2.386-.841 4.267-2.505 5.45-4.814.994-1.897 1.464-4.205 1.325-6.442-.105-1.36-.349-2.505-.767-3.597 0-.018 0-.035-.017-.053 0-.054-2.404-6.013-1.289-9.288a.975.975 0 0 0-.122-.877c-.035-.035-.052-.071-.104-.107.679-.25 1.114-.268 1.167-.268a.93.93 0 0 1 .783.375c.174.25.227.573.122.877-1.115 3.275 1.272 9.234 1.289 9.288v.053c.418 1.092.662 2.237.766 3.58h.018z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.967 12.14c-.627.215-1.48.644-2.334 1.414-.157-.34-.296-.662-.436-1.002 1.15-.627 2.02-.68 2.09-.68a.867.867 0 0 1 .68.268zM27.922 31.663c-.018 1.11-.384 2.362-1.01 3.436-.75 1.27-1.777 2.183-2.996 2.613-.749.25-1.48.393-2.195.393-.313 0-.644-.035-.94-.09.4-.07.801-.16 1.202-.303 1.219-.43 2.246-1.343 2.995-2.613.627-1.074.993-2.326.993-3.436.035-2.738-.94-5.511-3.152-8.983.035-.358.244-.68.61-.805a.92.92 0 0 1 1.062.375c2.386 3.669 3.448 6.568 3.43 9.413z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.49 22.25a.89.89 0 0 0-1.062-.357.933.933 0 0 0-.61.966c.105 1.503-.034 5.941-2.072 6.514-1.742.483-2.665-.34-2.752-.43a.911.911 0 0 0-.888-.268.954.954 0 0 0-.662.68c0 .071-.174.662-.244 1.038-.418 2.47.366 4.92 2.055 6.406.993.859 2.178 1.306 3.466 1.306.714 0 1.446-.125 2.195-.393 1.219-.43 2.247-1.325 2.995-2.613.627-1.074.993-2.326.993-3.436.018-2.845-1.027-5.762-3.43-9.43l.017.017z",
    stroke: "url(#pk7lmk4s3g)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.094 26.062c-.087-1.342-.33-2.487-.766-3.579 0 0 0-.036-.017-.053-.018-.054-2.404-6.013-1.29-9.288a.975.975 0 0 0-.121-.877.89.89 0 0 0-.784-.376c-.087 0-1.741.108-3.5 1.7-1.55-3.274-1.794-6.746-1.794-6.782a.933.933 0 0 0-.488-.77.87.87 0 0 0-.906.037c-2.438 1.503-4.32 3.364-5.59 5.476a13.65 13.65 0 0 0-1.882 5.636 14.48 14.48 0 0 0 0 3.257.563.563 0 0 1-.766.59l-2.368-1.001a.97.97 0 0 0-.506-.072c-.365.054-.644.322-.748.68-.21.77-.384 1.467-.488 2.165-.4 2.398-.244 4.868.47 7.122.714 2.273 1.968 4.224 3.588 5.655 1.933 1.682 4.267 2.541 6.81 2.541 1.41 0 2.873-.268 4.371-.787 2.386-.841 4.267-2.505 5.452-4.796.992-1.915 1.445-4.205 1.323-6.46v-.018z",
    stroke: "url(#80uzk8opth)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "psfnk9oyaa",
    x1: 10.864,
    y1: 22.044,
    x2: 33.114,
    y2: 22.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xt50j21gdb",
    x1: 10.881,
    y1: 29.027,
    x2: 22.819,
    y2: 29.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pxqo9wq3rc",
    x1: 15.88,
    y1: 13.474,
    x2: 24.734,
    y2: 13.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "um7og7ka5d",
    x1: 16.09,
    y1: 29.981,
    x2: 27.904,
    y2: 29.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8bgb6udtie",
    x1: 28.026,
    y1: 12.713,
    x2: 30.813,
    y2: 12.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6dhdlqg73f",
    x1: 13.57,
    y1: 20.484,
    x2: 15.939,
    y2: 20.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pk7lmk4s3g",
    x1: 10.864,
    y1: 22.044,
    x2: 33.114,
    y2: 22.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "80uzk8opth",
    x1: 10.864,
    y1: 22.044,
    x2: 33.114,
    y2: 22.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotOffers);
export default __webpack_public_path__ + "static/media/hotOffers.2b9012bc399edb2f9d1898adcfab3e8b.svg";
export { ForwardRef as ReactComponent };